module.exports = __webpack_public_path__ + "img/gallery_thumbnail.adac349b.svg";